import { render, staticRenderFns } from "./SamplesNotGeo.vue?vue&type=template&id=1fa816f2&scoped=true&"
import script from "./SamplesNotGeo.vue?vue&type=script&lang=js&"
export * from "./SamplesNotGeo.vue?vue&type=script&lang=js&"
import style0 from "./SamplesNotGeo.vue?vue&type=style&index=0&id=1fa816f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa816f2",
  null
  
)

export default component.exports